export default __webpack_public_path__ + "5216e4e904c8ecb2ebb203f67cdd3a1c.png";